/** @format */

import React from 'react';
import KeyForm from '../KeyForm';
import { useParams } from 'react-router-dom';

export default function KeyEdit() {
  const paramUrl = useParams();

  const clientId = paramUrl.client_id;
  return <KeyForm keyId={clientId} />;
}
